var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1818 9.07087C12.7659 10.4391 11.9324 11.6402 10.8 12.5034C9.80568 13.2576 8.62252 13.7175 7.38327 13.8317C6.14402 13.9458 4.89773 13.7096 3.78429 13.1495C2.67085 12.5895 1.73433 11.7278 1.07985 10.6611C0.42537 9.59447 0.0788317 8.36509 0.0791331 7.11098C0.0746589 5.64716 0.546848 4.2223 1.42326 3.05497C2.27978 1.91367 3.47165 1.0737 4.82928 0.654574C4.91876 0.626807 5.01406 0.624149 5.10492 0.646883C5.19579 0.669618 5.27878 0.716886 5.34499 0.783604C5.41119 0.850323 5.45809 0.933966 5.48065 1.02554C5.50321 1.11711 5.50057 1.21315 5.47302 1.30333C5.17615 2.29296 5.15126 3.34521 5.401 4.34797C5.65074 5.35074 6.16574 6.26643 6.89114 6.99748C7.61654 7.72853 8.52516 8.24755 9.52016 8.49923C10.5152 8.75092 11.5593 8.72583 12.5413 8.42665C12.6307 8.39889 12.726 8.39623 12.8169 8.41896C12.9078 8.4417 12.9908 8.48896 13.057 8.55568C13.1232 8.6224 13.1701 8.70604 13.1926 8.79762C13.2152 8.88919 13.2126 8.98523 13.185 9.07541L13.1818 9.07087Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIconDark);
export default __webpack_public_path__ + "static/media/switch-icon-dark.2c53f95bcee28d51c3a37e6f4d170067.svg";
export { ForwardRef as ReactComponent };